import clsx from "clsx"
import { FC, memo } from "react"
import { avatarDefaultSrc } from "@/assets"
import { ImageLoader } from "@/ui/ImageLoader"
import { IPlayerAvatar } from "."
import styles from "./PlayerAvatarV2.module.scss"
import { ClipAvatar } from "./ui/ClipAvatar"

const PlayerAvatarV2Component: FC<IPlayerAvatar> = ({
  src,
  hasVipPass,
  defaultAvatar = avatarDefaultSrc,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(styles.PlayerAvatar, className, {
        [styles.vip]: hasVipPass
      })}
      {...props}
    >
      {hasVipPass && (
        <>
          <ClipAvatar />
          <img
            className={clsx(styles.PlayerAvatar_vipBorder)}
            src={"/assets/images/vip-pass/avatar-border.webp"}
            alt=""
          />
        </>
      )}
      <div className={clsx(styles.PlayerAvatar_container)}>
        <ImageLoader src={src || defaultAvatar} spinner={{ size: 24 }} />
      </div>
    </div>
  )
}

export const PlayerAvatarV2 = memo(PlayerAvatarV2Component)
